import React from 'react'

import { Button, Modal, Rate, Select, Slider } from "antd";

const AddRoleModal = ({modal1Open,setModal1Open, typeName }) => {

  return (
   <>
    <Modal
                            className="doctor-filter-modal"
                            centered
                            open={modal1Open}
                            // onOk={() => setModal2Open(false)}
                            onCancel={() => setModal1Open(false)}
                            width={681}
                            footer={
                                <div className="row px-3 mt-lg-4 mb-lg-4">
                                    <div className="col-12 pt-3 pb-2 d-flex justify-content-center mt-3">
                                        <button className="apply-filter submit-pharmacy-edit">Submit</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="row px-3 border-bottom">
                                <div className="col-12 ">
                                    <p className="doc-add-filter">{typeName} Role</p>
                                </div>
                            </div>

             

                            <div className="row mt-4 px-3 ">
                    <div className="col-lg-6 pr-lg-1 doc-setting-input">
                      <p className="mb-2"> Role Type </p>
                      <Select
                        // defaultValue="lucy"
                        style={{
                          width: "100%",
                        }}
                        onChange={() => {}}
                        options={[
                          {
                            label: "Neurology",
                          },
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Cardiology​​",
                          },

                          {
                            label: "Neurology",
                          },
                        ]}
                      />
                    </div>

                    <div className="col-lg-6 mt-lg-0 mt-4 pl-lg-1 doc-setting-input">
                      <p className="mb-2"> Hospital</p>
                      <Select
                        // defaultValue="lucy"
                        style={{
                          width: "100%",
                        }}
                        onChange={() => {}}
                        options={[
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Neurology",
                          },
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Neurology",
                          },
                        ]}
                      />
                    </div>
                  </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Name</p>

                                    <input type="text" />
                                </div>
                            </div>
                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Email</p>

                                    <input type="text" />
                                </div>
                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                <p className="mb-2"> Country </p>
                      <Select
                        // defaultValue="lucy"
                        style={{
                          width: "100%",
                        }}
                        onChange={() => {}}
                        options={[
                          {
                            label: "Neurology",
                          },
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Cardiology​​",
                          },

                          {
                            label: "Neurology",
                          },
                        ]}
                      />
                                </div>
                            </div>



                            <div className="row mt-4 px-3 ">
                    <div className="col-lg-6 pr-lg-1 doc-setting-input">
                      <p className="mb-2"> Contact </p>
                    <input type="text" />
                    </div>

                    <div className="col-lg-6 mt-lg-0 mt-4 pl-lg-1 doc-setting-input">
                      <p className="mb-2"> State</p>
                      <Select
                        // defaultValue="lucy"
                        style={{
                          width: "100%",
                        }}
                        onChange={() => {}}
                        options={[
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Neurology",
                          },
                          {
                            label: "Cardiology​​",
                          },
                          {
                            label: "Neurology",
                          },
                        ]}
                      />
                    </div>
                  </div>
                        </Modal>
   </>
  )
}

export default AddRoleModal